import {axios} from '@/utils/request'

/**
 * 查询护士端-用户表
 * @author wl
 * @date 2024-07-22 14:27:11
 */
export function baNurseUserPage(parameter) {
  return axios({
    url: '/baNurseUser/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 护士端-用户表列表
 * @author wl
 * @date 2024-07-22 14:27:11
 */
export function baNurseUserList(parameter) {
  return axios({
    url: '/baNurseUser/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加护士端-用户表
 * @author wl
 * @date 2024-07-22 14:27:11
 */
export function baNurseUserAdd(parameter) {
  return axios({
    url: '/baNurseUser/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑护士端-用户表
 * @author wl
 * @date 2024-07-22 14:27:11
 */
export function baNurseUserEdit(parameter) {
  return axios({
    url: '/baNurseUser/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除护士端-用户表
 * @author wl
 * @date 2024-07-22 14:27:11
 */
export function baNurseUserDelete(parameter) {
  return axios({
    url: '/baNurseUser/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出护士端-用户表
 * @author wl
 * @date 2024-07-22 14:27:11
 */
export function baNurseUserExport(parameter) {
  return axios({
    url: '/baNurseUser/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * @Description: 护士备案
 * @author wl
 * @date 2024/7/22 15:35
 */
export function updateNurseRecord(params) {
  return axios({
    url: '/baNurseUser/updateRecordState',
    method: 'get',
    params: params
  })
}
